import Vue from 'vue'
import Router from 'vue-router'
import TThinkPage from '@/components/pages/TThinkPage'
import WordsPage from '@/components/pages/WordsPage'
import ThinksPage from '@/components/pages/ThinksPage'
import RegistUserPage from '@/components/pages/RegistUserPage'
import LoginPage from '@/components/pages/LoginPage'
import ProfilePage from '@/components/pages/ProfilePage'
import RequestResetPasswordPage from '@/components/pages/RequestResetPasswordPage'
import ResetPasswordPage from '@/components/pages/ResetPasswordPage'
import LandingPage from '@/components/pages/LandingPage'
import PrintPage from '@/components/pages/PrintPage'
//import LoginPhonePage from '@/components/pages/LoginPhonePage'
import LoginHome from '@/components/LoginHome'
import LoginPhone from '@/components/LoginPhone'
import store from './../store.js'

Vue.use(Router)

//認証が必要なページには以下を付与する
// meta: { requiresAuth: true }
const router = new Router({
  //mode: 'history',//URLにハッシュをつけないモード
  routes: [
    {
      path: '*',
      // redirect: 'login'
      redirect: 'landing'
    },
    // {
    //   path: '/loginphone',
    //   name: 'LoginPhonePage',
    //   component:LoginPhonePage
    // },
    {
      path: '/print/:thinkID/:wordID',
      name: 'PrintPage',
      props: true, // パラメーターをpropsとして受け取る
      component: PrintPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/landing',
      name: 'LandingPage',
      component: LandingPage
    },
    {
      path: '/thinkpage',
      name: 'ThinksPage',
      component: ThinksPage,
      meta: { requiresAuth: true }
    },
    {
      path: '/thinkwords/:thinkID',
      name: 'WordsPage',
      component: WordsPage,
      props: true, // パラメーターをpropsとして受け取る
      meta: { requiresAuth: true }
    },
    {
      path: '/think/:thinkID/:wordID',
      name: 'TThinkPage',
      component: TThinkPage,
      props: true, // パラメーターをpropsとして受け取る
      meta: { requiresAuth: true }
    },
    {
      //ユーザー登録
      path: '/signup',
      name: 'SignUp',
      component: RegistUserPage
    },
    {
      //プロフィール
      path: '/profile',
      name: 'ProfilePage',
      component: ProfilePage,
      meta: { requiresAuth: true }
    },
    {
      //ログイン
      path: '/login',
      name: 'LoginPage',
      props: true, // パラメーターをpropsとして受け取る
      component: LoginPage,
      children:[
        {
          name: 'login-home',
          path: '',
          component: LoginHome
        }
        // 電話ログインは廃止。Firebase有料化にともない.2024.9
        // {
        //   name: 'login-phone',
        //   path: 'phone',
        //   component: LoginPhone
        // }
      ]
    },
    {
      //パスワードリセット要求
      path: '/request_reset_password',
      name: 'RequestResetPasswordPage',
      component: RequestResetPasswordPage
    },
    {
      //パスワードリセット
      path: '/reset_password',
      name: 'ResetPasswordPage',
      component: ResetPasswordPage
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth) {

    firebase.auth().onAuthStateChanged(function (user) {

      //path1.認証OK:望みのページへ遷移
      if (user) {
        next()
        return
      }

      //path2:認証されていない場合は強制的に「ログイン」ページへ遷移
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    })
  } else {
    next() // next() を常に呼び出すようにしてください!
  }
})

//生成したルーターをエクスポート
export default router


// WEBPACK FOOTER //
// ./src/router/index.js